export default __webpack_public_path__ + "static/media/invictus_banner_mweb.2e8e15c2.png";